<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <v-autocomplete
              :value="project"
              :items="projects"
              :loading="projectLoading"
              :search-input.sync="projectSearch"
              clearable
              outlined
              hide-no-data
              hide-details
              dense
              hide-selected
              item-text="title"
              item-value="id"
              label="Проект"
              placeholder="Введіть iм'я проекту"
              return-object
              :rules="[v => !!v || 'Проект обов’язковий']"
              @change="handleChange"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch
              v-model="fixPrice"
              label="Fix price"
              hide-details
              dense
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="!valid"
          text
          :loading="loading"
          color="primary"
          @click="addProject"
        >
          Ок
        </v-btn>
        <v-btn
          text
          @click="close"
        >
          Відмінити
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import * as projectsApi from "@/backend/projectsApi.js";

export default {
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    project: null,
    projects: [],
    projectSearch: null,
    projectLoading: false,
    valid: false,
    fixPrice: false,
    loading: false,
  }),
  watch: {
    async projectSearch(val) {
      if (this.projectLoading) {
        return;
      }

      if (this.projectLoading && this.project.title === val) {
        return;
      }

      if (!val) {
        this.projects = [];
        return;
      }

      try {
        this.projectLoading = true;
        this.projects = await projectsApi.getProjectsWithoutClient(val);
      } catch {
        this.$notifyWarning();
      } finally {
        this.projectLoading = false;
      }
    },
  },
  methods: {
    async addProject() {
      try {
        this.loading = true;
        await projectsApi.assignProjectToClient(this.project.id, {
          clientId: this.clientId,
          fixPrice: this.fixPrice,
        });
        this.$emit("add", {
          id: this.project.id,
          title: this.project.title,
          key: this.project.key,
          fixPrice: this.fixPrice,
        });
        this.close();
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.project = null;
      this.fixPrice = false;
      this.$refs.form.resetValidation();
      this.$emit("close");
    },
    handleChange({ fixPrice, id, title, key }) {
      this.fixPrice = fixPrice;
      this.project = { id, title, key };
    },
  },
};
</script>
